import { getFilterConfig } from '../../../utils/filter';
import { FILTER } from '../../../data/enums/filter';

const filter = getFilterConfig([FILTER.HIERARCHY_STATUS]);

export { filter as filterConfig };
